import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaBars, FaTimes, FaUserCircle } from "react-icons/fa";
import { logoutUser } from "../../redux/slices/authSlice";
import { Link } from "react-router-dom"; // Ensure this is imported
import styles from "../../styles/Navbar/RoleNavbar.module.css";

// Sub-components
import GuestNavbar from "./GuestNavbar";
import BuyerNavbar from "./BuyerNavbar";
import SellerNavbar from "./SellerNavbar";
import TransporterNavbar from "./TransporterNavbar";
import AdminNavbar from "./AdminNavbar";
import NavbarSearch from "./NavbarSearch";
import BuyerProfileMenu from "./BuyerProfileMenu";
import GuestActions from "./GuestActions";
import UserProfileCard from "./UserProfileCard";
import LogoutButton from "./LogoutButton";
import NavbarLogo from "./NavbarLogo";

import useNavbarRole from "../../hooks/useNavbarRole";
import useAutoLogout from "../../hooks/useAutoLogout";
import NavbarAd from "./NavbarAd";


function RoleNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user } = useSelector((state) => state.auth);

  useAutoLogout();
  const {
    isGuest,
    isBuyer,
    isSeller,
    isTransporter,
    isDashboardUser,
    getLogoPath,
  } = useNavbarRole(user);

  // Auto-close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const handleLogout = () => {
    dispatch(logoutUser());
    setMobileMenuOpen(false);
    navigate("/");
  };

  // --- FAILSALFE GREETING LOGIC ---
  const getUserGreetingName = () => {
    // 1. Check all common profile name fields from Redux state
    const rawName =
      user?.username ||
      user?.name ||
      user?.fullName ||
      user?.companyName ||
      user?.role ||
      "User";

    // 2. Clean it up, grab the first name/word
    const firstName = rawName.trim().split(" ")[0];

    // 3. Force proper capitalization (e.g., "buyer" -> "Buyer", "john" -> "John")
    return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
  };

  return (
    <header className={styles.navbarWrapper}>
      {/* --- TOP BAR (Logo, Search, Profile) --- */}
      <div className={styles.topNavbar}>
        <div className={styles.navInner}>
          <div className={styles.headerMainRow}>
            {/* LEFT: Mobile Toggle + Logo */}
            <div className={styles.leftSection}>
              <button
                className={styles.mobileMenuBtn}
                onClick={() => setMobileMenuOpen(true)}
              >
                <FaBars />
              </button>
              <NavbarLogo logoPath={getLogoPath()} />
            </div>

            {/* MIDDLE: Laptop Search (Hidden on Mobile) */}
            {/* MIDDLE: Laptop Search */}
{(isGuest || isBuyer) && (
  <div className={styles.desktopSearchBox}>
    <NavbarSearch />
  </div>
)}

{/* SMALL PERMANENT NAVBAR AD */}
{(isGuest || isBuyer) && (
  <NavbarAd />
)}

            {/* RIGHT: User Context & Actions */}
            <div className={styles.rightSection}>
              {/* Dashboard links for Admin/Seller on Desktop */}
              <div className={styles.desktopDashboardLinks}>
                {isSeller && <SellerNavbar location={location} />}

                {isTransporter && <TransporterNavbar location={location} />}

                {user?.role === "admin" && <AdminNavbar location={location} />}
              </div>

              {!isGuest ? (
                <div className={styles.userActionsGroup}>
                  {/* Wrap the greeting pill in a Link */}
                  <Link to="/seller-profile" className={styles.userGreetingLink}>
                    <div className={styles.userGreetingPill}>
                      <FaUserCircle className={styles.userIcon} />
                      <span className={styles.greetingText}>
                        Hi, {getUserGreetingName()}
                      </span>
                    </div>
                  </Link>

                  {/* Separate Logout Button */}
                  <div className={styles.desktopLogoutContainer}>
                    <LogoutButton onLogout={handleLogout} />
                  </div>
                </div>
              ) : (
                <div className={styles.desktopGuestActions}>
                  <GuestActions />
                </div>
              )}
            </div>
          </div>

          {/* MOBILE ONLY: Search Bar Row 2 */}
          {(isGuest || isBuyer) && !mobileMenuOpen && (
            <div className={styles.mobileSearchRow}>
              <NavbarSearch />
            </div>
          )}
        </div>
      </div>

      {/* --- BOTTOM NAV: Navigation Links (Laptops Only) --- */}
      {(isGuest || isBuyer) && (
        <nav className={styles.bottomNavbarDesktop}>
          <div className={styles.bottomInner}>
            {isGuest ? (
              <GuestNavbar location={location} />
            ) : (
              <BuyerNavbar location={location} />
            )}
          </div>
        </nav>
      )}

      {/* --- MOBILE FULLSCREEN OVERLAY --- */}
      <div
        className={`${styles.mobileOverlay} ${mobileMenuOpen ? styles.mobileMenuOpen : ""}`}
      >
        <div className={styles.overlayHeader}>
          <button
            className={styles.closeBtn}
            onClick={() => setMobileMenuOpen(false)}
          >
            <FaTimes />
          </button>
        </div>

        <div className={styles.mobileMenuContent}>
          {/* Mobile Profile Display */}
          {!isGuest && (
            <div className={styles.mobileProfileCard}>
              {isBuyer ? (
                <BuyerProfileMenu user={user} />
              ) : (
                <UserProfileCard user={user} />
              )}
            </div>
          )}

          {/* Mobile Vertical Navigation */}
          <nav className={styles.mobileVerticalNav}>
            {isDashboardUser ? (
              isSeller ? (
                <SellerNavbar location={location} />
              ) : isTransporter ? (
                <TransporterNavbar location={location} />
              ) : (
                <AdminNavbar location={location} />
              )
            ) : isGuest ? (
              <GuestNavbar location={location} />
            ) : (
              <BuyerNavbar location={location} />
            )}
          </nav>

          {/* Mobile Action Footer */}
          <div className={styles.mobileActionFooter}>
            {isGuest ? (
              <GuestActions />
            ) : (
              <LogoutButton onLogout={handleLogout} />
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default RoleNavbar;
